import { apiClient } from '@/services/api/client'
import type {
  AiInsight,
  InsightRunSummary,
  InsightStatus,
  Lens,
  ProbeHint,
  RunStarted,
} from '../types'

export const aiInsightsApi = {
  list: (caseId: string, lens: Lens = 'graph', status: InsightStatus = 'active') =>
    apiClient.get<AiInsight[]>(`/v1/cases/${caseId}/ai-insights`, {
      params: { lens, status },
    }),

  refresh: (caseId: string, lens: Lens = 'graph') =>
    apiClient.post<RunStarted>(`/v1/cases/${caseId}/ai-insights/refresh`, undefined, {
      params: { lens },
    }),

  probe: (caseId: string, hint: ProbeHint) =>
    apiClient.post<RunStarted>(`/v1/cases/${caseId}/ai-insights/probe`, hint),

  accept: (caseId: string, insightId: string) =>
    apiClient.post<AiInsight>(`/v1/cases/${caseId}/ai-insights/${insightId}/accept`),

  skip: (caseId: string, insightId: string) =>
    apiClient.post<AiInsight>(`/v1/cases/${caseId}/ai-insights/${insightId}/skip`),

  runs: (
    caseId: string,
    status: 'running' | 'done' | 'failed' | 'aborted' | 'all' = 'all',
    limit = 50
  ) =>
    apiClient.get<InsightRunSummary[]>(`/v1/cases/${caseId}/ai-insights/runs`, {
      params: { status, limit },
    }),
}
